module.exports = __webpack_public_path__ + "static/img/desktop-xmlx.de73454a.png";